export default "/images/close.svg?3b40e78436c6bbb754e0ed1d6d7c501f";